import UEditor from './UEditor.vue'
export default UEditor